import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function Pagination({ page, totalPages, total, pageSize, onPageChange }) {
  if (totalPages <= 1) return null;

  const startItem = (page - 1) * pageSize + 1;
  const endItem = Math.min(page * pageSize, total);

  const pages = [];
  const maxVisible = 5;
  let start = Math.max(1, page - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);
  if (end - start < maxVisible - 1) start = Math.max(1, end - maxVisible + 1);

  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div data-testid="pagination-controls" className="flex flex-col sm:flex-row items-center justify-between gap-3 mt-4 pt-4 border-t border-gray-100">
      <p className="text-xs text-gray-500">
        {startItem}-{endItem} de {total}
      </p>
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" className="h-8 w-8" disabled={page <= 1} onClick={() => onPageChange(1)} data-testid="page-first">
          <ChevronsLeft className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8" disabled={page <= 1} onClick={() => onPageChange(page - 1)} data-testid="page-prev">
          <ChevronLeft className="w-4 h-4" />
        </Button>
        {pages.map(p => (
          <Button key={p} variant={p === page ? 'default' : 'ghost'} size="icon"
            className={`h-8 w-8 text-xs ${p === page ? 'bg-[#003366] text-white hover:bg-[#004080]' : ''}`}
            onClick={() => onPageChange(p)} data-testid={`page-${p}`}
          >
            {p}
          </Button>
        ))}
        <Button variant="ghost" size="icon" className="h-8 w-8" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)} data-testid="page-next">
          <ChevronRight className="w-4 h-4" />
        </Button>
        <Button variant="ghost" size="icon" className="h-8 w-8" disabled={page >= totalPages} onClick={() => onPageChange(totalPages)} data-testid="page-last">
          <ChevronsRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
